import { render } from "./TestOption.vue?vue&type=template&id=51ec7718&scoped=true"
import script from "./TestOption.vue?vue&type=script&lang=js"
export * from "./TestOption.vue?vue&type=script&lang=js"

import "./TestOption.vue?vue&type=style&index=0&id=51ec7718&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ec7718"]])

export default __exports__